export const TYPES = {
  GENERIC_REQUEST: 'GENERIC_REQUEST',
  GENERIC_ERROR: 'GENERIC_ERROR',
  FETCH_PAYLOAD_SUCCESS: 'FETCH_PAYLOAD_SUCCESS',
  GET_QUOTE_SUCCESS: 'GET_QUOTE_SUCCESS',
  CREATE_ORDER_SUCCESS: 'CREATE_ORDER_SUCCESS',
  GET_OPEN_ENDED_TOKEN_SUCCESS: 'GET_OPEN_ENDED_TOKEN_SUCCESS',
  GET_INTERNAL_QUOTE_SUCCESS: 'GET_INTERNAL_QUOTE_SUCCESS',
  CREATE_GLOBAL_QUOTED_TICKETS_SUCCESS: 'CREATE_GLOBAL_QUOTED_TICKETS_SUCCESS',
  REMOVE_GLOBAL_QUOTED_TICKETS_SUCCESS: 'REMOVE_GLOBAL_QUOTED_TICKETS_SUCCESS',
  REMOVE_ALL_GLOBAL_QUOTED_TICKETS_SUCCESS: 'REMOVE_ALL_GLOBAL_QUOTED_TICKETS_SUCCESS',
  SAVE_USER_INFORMATION_SUCCESS: 'SAVE_USER_INFORMATION_SUCCESS',
  VALIDATE_PCW_TOKEN_SUCCESS: 'VALIDATE_PCW_TOKEN_SUCCESS',
};

export default {
  [TYPES.GENERIC_REQUEST](state, type) {
    const currentState = state;
    currentState[type].loading = true;
    currentState[type].successMessage = '';
    currentState[type].errorMessage = '';
  },
  [TYPES.GENERIC_ERROR](state, errorInfo) {
    const currentState = state;
    currentState[errorInfo.type].errorMessage = errorInfo.message;
    currentState[errorInfo.type].successMessage = '';
    currentState[errorInfo.type].loading = false;
  },
  [TYPES.FETCH_PAYLOAD_SUCCESS](state, data) {
    const currentState = state;
    currentState.payloadDetails.data = data;
    currentState.payloadDetails.customer = data.payload.customer;
    currentState.payloadDetails.billingAddress = data.payload.billing_address;
    currentState.payloadDetails.orderToken = data.payload.order_number;
    currentState.payloadDetails.expiresOn = data.expires_on;
    currentState.payloadDetails.created = data.created;
    currentState.payloadDetails.uuid = data.uuid;
    currentState.payloadDetails.orderItems = data.payload.items;
    currentState.payloadDetails.currency = data.payload.currency_symbol;
    currentState.payloadDetails.errorMessage = '';
    currentState.payloadDetails.loading = false;
  },
  [TYPES.GET_QUOTE_SUCCESS](state, data) {
    const currentState = state;
    currentState.quoteDetails.data = data;
    currentState.quoteDetails.quote = data.quote;
    currentState.quoteDetails.symbol = data.symbol;
    currentState.quoteDetails.quoteLiteral = data.quote_literal;
    currentState.quoteDetails.surcharge = data.surcharge;
    currentState.quoteDetails.errorMessage = '';
    currentState.quoteDetails.successMessage = '';
    currentState.quoteDetails.loading = false;
  },
  [TYPES.CREATE_ORDER_SUCCESS](state, data) {
    const currentState = state;
    currentState.orderDetails.data = data;
    currentState.orderDetails.orderNumber = data.order_number;
    currentState.orderDetails.errorMessage = '';
    currentState.orderDetails.successMessage = '';
    currentState.orderDetails.loading = false;
  },
  [TYPES.GET_OPEN_ENDED_TOKEN_SUCCESS](state, data) {
    const currentState = state;
    currentState.openEndedTokenDetails.data = data;
    currentState.openEndedTokenDetails.client = data.client;
    currentState.openEndedTokenDetails.currency = data.currency;
    currentState.openEndedTokenDetails.currencySymbol = data.currency_symbol;
    currentState.openEndedTokenDetails.isExpired = data.is_expired;
    currentState.openEndedTokenDetails.url = data.url;
    currentState.openEndedTokenDetails.errorMessage = '';
    currentState.openEndedTokenDetails.successMessage = '';
    currentState.openEndedTokenDetails.loading = false;
  },
  [TYPES.GET_INTERNAL_QUOTE_SUCCESS](state, data) {
    const currentState = state;
    currentState.internalQuoteDetails.data = data;
    currentState.internalQuoteDetails.currency = data.currency;
    currentState.internalQuoteDetails.quoteLiteral = data.quoteLiteral;
    currentState.internalQuoteDetails.orderLiteral = data.order_literal;
    currentState.internalQuoteDetails.quote = data.quote;
    currentState.internalQuoteDetails.total = data.total;
    currentState.internalQuoteDetails.symbol = data.symbol;
    currentState.internalQuoteDetails.errorMessage = '';
    currentState.internalQuoteDetails.successMessage = '';
    currentState.internalQuoteDetails.loading = false;
  },
  [TYPES.CREATE_GLOBAL_QUOTED_TICKETS_SUCCESS](state, data) {
    const currentState = state;
    currentState.globalQuotedTicketsDetails.globalQuotedTickets = data.quotedTickets;
    currentState.globalQuotedTicketsDetails.count = data.count;
    currentState.globalQuotedTicketsDetails.errorMessage = '';
    currentState.globalQuotedTicketsDetails.successMessage = '';
    currentState.globalQuotedTicketsDetails.loading = false;
  },
  [TYPES.REMOVE_GLOBAL_QUOTED_TICKETS_SUCCESS](state, data) {
    const currentState = state;
    currentState.globalQuotedTicketsDetails.globalQuotedTickets = data.quotedTickets;
    currentState.globalQuotedTicketsDetails.count = data.count;
    currentState.globalQuotedTicketsDetails.errorMessage = '';
    currentState.globalQuotedTicketsDetails.successMessage = '';
    currentState.globalQuotedTicketsDetails.loading = false;
  },
  [TYPES.REMOVE_ALL_GLOBAL_QUOTED_TICKETS_SUCCESS](state) {
    const currentState = state;
    currentState.globalQuotedTicketsDetails.globalQuotedTickets = {};
    currentState.globalQuotedTicketsDetails.errorMessage = '';
    currentState.globalQuotedTicketsDetails.successMessage = '';
    currentState.globalQuotedTicketsDetails.loading = false;
  },
  [TYPES.SAVE_USER_INFORMATION_SUCCESS](state, data) {
    const currentState = state;
    currentState.globalQuotedTicketsDetails.userInformation = data;
    currentState.globalQuotedTicketsDetails.errorMessage = '';
    currentState.globalQuotedTicketsDetails.successMessage = '';
    currentState.globalQuotedTicketsDetails.loading = false;
  },
  [TYPES.REMOVE_ALL_GLOBAL_QUOTED_TICKETS_SUCCESS](state) {
    const currentState = state;
    currentState.globalQuotedTicketsDetails.globalQuotedTickets = {};
    currentState.globalQuotedTicketsDetails.errorMessage = '';
    currentState.globalQuotedTicketsDetails.successMessage = '';
    currentState.globalQuotedTicketsDetails.loading = false;
  },
};
